import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from 'components/Button';
import React from 'react';

const MessageContent = ({ message, onCTAClick }) => {
  return (
    <Box mt={3}>
      <Box
        dangerouslySetInnerHTML={{
          __html: message.message,
        }}
      />
    </Box>
  );
};

export default MessageContent;
